import React from "react";
import T from "prop-types";
import { FaTrash } from 'react-icons/fa';

export const IconButton = ({ className, onClick }) => (
    <button className={className}>
        <FaTrash className={""} color={"red"} onClick={onClick} />
    </button>
);

IconButton.T = {
    onClick: T.func,
    className: T.string,
};

IconButton.defaultProps = {
    onClick: null,
    className: "primaryButtonCls",
};
